module.exports = "/_next/static/images/PyConfHyderabad2-061d33c13d854145842802f6b22bd4bd.jpg";